import { formErrorMessages } from 'api/resources/responseMessages/formErrors';
import { SelectOption } from 'components/Select';
import * as Yup from 'yup';
import { DLG_ID } from '../constants';

export interface CustomRepairerFNOLForm {
  workProviderID?: number;
  sourceRepairerCode: string | null;
  deployToSiteCode: string | null;
  externalSiteCode: string | null;
  streamCodeToUse: string | null;
  deployToEmailAddress: string | null;
  connectionType?: SelectOption | null;
}

export const validation = Yup.object({
  workProviderID: Yup.number().required(formErrorMessages.required),
  sourceRepairerCode: Yup.string().required(formErrorMessages.required),
  deployToSiteCode: Yup.string(),
  connectionType: Yup.object({
    id: Yup.number().required(formErrorMessages.required),
    text: Yup.string().required(formErrorMessages.required),
    value: Yup.string().required(formErrorMessages.required),
  })
    .nullable()
    .required(formErrorMessages.required),
  externalSiteCode: Yup.string(),
  streamCodeToUse: Yup.string()
    .when('workProviderID', {
    is: (WP: number) => WP != DLG_ID,
    then: Yup.string().required(formErrorMessages.required),
  }),
});
